import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { StorageManagerService } from '../../shared/services/index';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';


@Component({
  selector: 'app-submission-identity-classification-sk',
  templateUrl: './submission-identity-classification-sk.component.html',
  styleUrls: ['./submission-identity-classification-sk.component.scss']
})
export class SubmissionIdentityClassificationSKComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {
    super(fb, storage);
   }

  ngOnInit() {
    this.itemType = this.itemData.documentType;

    this.dataScope = this.storage.read('dataScope');

    this.initializeMainForm();

    this.patchForms();
  }


  initializeMainForm() {

    this.deviceForm = this.fb.group({
      udiDI: ['', { validators: [] }],
      agency: ['', { validators: [] }],
      quantityOfDevice: ['', { validators: [] }],
      isExpirationDate: ['', { validators: [] }],
      isManufacturingDate: ['', { validators: [] }],
      isLotOrBatchNumber: ['', { validators: [] }],
      isSerialNumber: ['', { validators: [] }],
      isSwVersion: ['', { validators: [] }],
      versionOrModel: ['', { validators: [] }],
      softwareAsAMedicalDevice: ['', { validators: [] }]
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
    });
  }

  get deviceDescriptionForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('deviceDescriptionForm');
  }

  addDeviceDescriptionForm(): FormGroup {

    return this.fb.group({
      value: ['', { validators: [] }],
      language: ['', { validators: [] }]
    });
  }

  patchForms() {
    this.deviceForm.patchValue({

      udiDI: this.displayItemData('Primary DI'),
      agency: this.displayItemData('Primary DI Issuing Agency'),
      quantityOfDevice: this.displayItemData('Quantity of Device'),
      isExpirationDate: this.displayItemData('Controlled by Expiration Date?'),
      isManufacturingDate: this.displayItemData('Controlled by Manufacturing Date?'),
      isLotOrBatchNumber: this.displayItemData('Controlled by Lot or Batch Number?'),
      isSerialNumber: this.displayItemData('Controlled by Serial Number?'),
      isSwVersion: this.displayItemData('Controlled By Software Version?'),
      versionOrModel: this.displayItemData('Version or Model'),
      softwareAsAMedicalDevice: this.displayItemData('Software as a Medical Device')
    });

    this.deviceForm.setControl('deviceDescriptionForm', this.setDeviceDescriptionForm());
  }


  setDeviceDescriptionForm(): FormArray {

    const formArray = new FormArray([]);

    let items: any;

    items = this.displayItemData('Device Description');

    if (items && items.length > 0) {
      items.forEach((c, i) => {
          formArray.push(

                this.fb.group({
                  value: c[(this.getMapInnerPathName('Device Description Value'))[0]],
                  language: c[(this.getMapInnerPathName('Device Description Language'))[0]]
                })
            );
        });
    }

    return formArray;
  }
}
